import dentiumLoginImage from '@/assets/img/login/dentium-login-image-1.png';
import dentalmaxLoginImage from '@/assets/img/login/dentalmax-login-image-1.webp';

/**
 * 테넌트(고객사) 설정 레지스트리.
 *
 * 향후 신규 고객사 추가 시 본 객체에 항목 1개 등록만으로 brand 분기 완료.
 * 기존 코드 (Signin.vue computed 등) 수정 0건 = SOLID OCP 준수.
 *
 * @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-TENANT-REGISTRY-001 — hostname 기반 brand 분기 통합 (Strategy + Registry 패턴)
 *   기존: Signin.vue:152,159 hostname.includes('dentalmax') 분기 inline 2곳
 *   현재: tenantRegistry 단일 진입점, computed는 resolveTenant() 호출만
 *   향후 DentalXYZ 등 추가 시 본 객체에 1 항목 등록 (기존 코드 수정 0건)
 * @MX:SPEC: SPEC-CHINA-ADMIN-TENANT-REGISTRY-001
 */
const TENANT_REGISTRY = {
  dentium: {
    id: 'dentium',
    hostnameKeyword: null, // default fallback (hostname 매칭 없을 때)
    loginImage: dentiumLoginImage,
    leftBgClass: '',
    // 제조사 도메인 — 종전 하드코딩 배열을 그대로 옮김 (MANUFACTURER 우선, 실패 시 기공소)
    loginRoles: ['MANUFACTURER', 'DENTAL_LABORATORY'],
  },
  dentalmax: {
    id: 'dentalmax',
    hostnameKeyword: 'dentalmax',
    loginImage: dentalmaxLoginImage,
    leftBgClass: 'is-dentalmax',
    loginRoles: ['MANUFACTURER', 'DENTAL_LABORATORY'],
  },
  // [2026-08-03] hospital.xinlaian.cn — 같은 앱을 병원 대상 도메인으로도 서빙한다
  // (SWA 멀티도메인 바인딩, 별도 빌드·배포 없음). 이 항목이 하는 일은 두 가지다:
  //   ① 로그인 시도 role 을 HOSPITAL 로 한정 — BE canLoginAs 는 HOSPITAL→HOSPITAL 을
  //      원래 허용하므로 BE 인증 변경 없이 병원 로그인이 열린다
  //   ② 병원 도메인에서 제조사·기공소 로그인을 차단 — 역할과 도메인을 일치시킨다
  // 화면 접근은 종전대로 privileges(사이드바) + BE @Roles 가 막는다.
  hospital: {
    id: 'hospital',
    hostnameKeyword: 'hospital.',
    loginImage: dentiumLoginImage,
    leftBgClass: '',
    loginRoles: ['HOSPITAL'],
  },
};

/**
 * hostname으로 테넌트 해석.
 *
 * - hostname에 keyword 포함된 첫 매치 반환
 * - 매치 0건 시 기본 dentium 반환 (fallback)
 * - SSR safe (hostname null/undefined도 fallback)
 *
 * @param {string} hostname - window.location.hostname
 * @returns 테넌트 설정 객체 (id/hostnameKeyword/loginImage/leftBgClass)
 */
export function resolveTenant(hostname) {
  if (typeof hostname !== 'string') return TENANT_REGISTRY.dentium;
  return (
    Object.values(TENANT_REGISTRY).find(
      (t) => t.hostnameKeyword && hostname.includes(t.hostnameKeyword),
    ) ?? TENANT_REGISTRY.dentium
  );
}

export { TENANT_REGISTRY };
